module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_uwashington-13c81099be6547260f70101499f73fc0.png";